// extracted by mini-css-extract-plugin
export var company_logo_item = "index-module--company_logo_item--d3129";
export var company_logos = "index-module--company_logos--e7188";
export var company_logos_container = "index-module--company_logos_container--9cf1d";
export var logoMove = "index-module--logo-move--143c8";
export var logo_container = "index-module--logo_container--55c04";
export var logo_container_wrapper = "index-module--logo_container_wrapper--052d6";